import Link from 'next/link';
import { useState, useEffect } from 'react';

import { getLatest } from '../../api/News';
import { formatDate } from '../../utils/dayjs';

import styles from './LatestNews.module.scss';

export default function LatestNews() {
  const [data, setData] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const contentType = 'news';
      const res = await getLatest(contentType);
      setData(res.data);
    }

    try {
      fetchData();
    } catch (error) {
      console.log(error);
    }
  }, []);

  return (
    <div className={styles.latestNewsContainer}>
      <h5 className={styles.title}>Τελευταίες Δημοσιεύσεις</h5>
      <div>
        {data.map((news, index) => (
          <div key={news.uuid} className={styles.twoLineList}>
            <Link href={`${news.slug}`}>
              <a className={styles.newsTitle}>
                <h6>{news.title}</h6>
              </a>
            </Link>
            <p className={styles.latestNewsText}>
              <i className="mdi mdi-calendar-text" />
              {formatDate(news.ct, 'L')}
            </p>
            {index < data.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </div>
  );
}
